(() => {
  if (window.YutaLoadMoreInitialized) return;
  window.YutaLoadMoreInitialized = true;

  const buttonSelector = '[data-load-more-products]';
  const infiniteSelector = '[data-all-products-infinite]';

  let infiniteLoading = false;
  let lastScrollY = window.scrollY;

  async function fetchNextPage(nextUrl) {
    const response = await fetch(nextUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    const html = await response.text();

    return new DOMParser().parseFromString(
      html,
      'text/html'
    );
  }

  async function loadMoreButton(button) {
    if (!button || button.disabled) return;

    const nextUrl = button.dataset.nextUrl;
    const container = button.closest('#ProductGridContainer');
    const grid = container?.querySelector('#product-grid');
    const wrapper = button.closest('[data-load-more-wrapper]');
    const text = button.querySelector('[data-load-more-text]');

    if (!nextUrl || !grid) return;

    const originalText =
      text?.textContent || 'Load More Products';

    button.disabled = true;

    if (text) {
      text.textContent = 'Loading…';
    }

    try {
      const nextDocument = await fetchNextPage(nextUrl);

      const nextContainer =
        nextDocument.querySelector('#ProductGridContainer');

      const nextGrid =
        nextContainer?.querySelector('#product-grid');

      const nextButton =
        nextContainer?.querySelector(buttonSelector);

      if (!nextGrid) {
        throw new Error('Next product grid not found');
      }

      Array.from(nextGrid.children).forEach((item) => {
        const newItem = document.importNode(item, true);

        newItem.classList.remove(
          'scroll-trigger',
          'animate--slide-in'
        );

        newItem.removeAttribute('data-cascade');
        newItem.style.removeProperty('--animation-order');

        grid.appendChild(newItem);
      });

      if (nextButton?.dataset.nextUrl) {
        button.dataset.nextUrl =
          nextButton.dataset.nextUrl;

        button.disabled = false;

        if (text) {
          text.textContent = originalText;
        }
      } else {
        wrapper?.remove();
      }
    } catch (error) {
      console.error('Load More error:', error);

      button.disabled = false;

      if (text) {
        text.textContent = 'Try Again';
      }
    }
  }

  async function loadInfiniteProducts(trigger) {
    if (!document.body.classList.contains('template-collection')) return;
    if (!trigger || infiniteLoading) return;

    const nextUrl = trigger.dataset.nextUrl;
    const container = trigger.closest('#ProductGridContainer');
    const grid = container?.querySelector('#product-grid');

    if (!nextUrl || !grid) return;

    infiniteLoading = true;

    try {
      const nextDocument = await fetchNextPage(nextUrl);

      const nextContainer =
        nextDocument.querySelector('#ProductGridContainer');

      const nextGrid =
        nextContainer?.querySelector('#product-grid');

      const nextTrigger =
        nextContainer?.querySelector(infiniteSelector);

      if (!nextGrid) {
        throw new Error('Next product grid not found');
      }

      Array.from(nextGrid.children).forEach((item) => {
        const newItem = document.importNode(item, true);

        newItem.classList.remove(
          'scroll-trigger',
          'animate--slide-in'
        );

        newItem.removeAttribute('data-cascade');
        newItem.style.removeProperty('--animation-order');

        grid.appendChild(newItem);
      });

      if (nextTrigger?.dataset.nextUrl) {
        trigger.dataset.nextUrl =
          nextTrigger.dataset.nextUrl;
      } else {
        trigger.remove();
      }
    } catch (error) {
      console.error(
        'All Products infinite scroll error:',
        error
      );
    } finally {
      infiniteLoading = false;
    }
  }

  function checkInfiniteScroll() {
   const trigger =
  document.querySelector(
    '[data-all-products-infinite][data-all-products-page="true"]'
  );
    if (!trigger || infiniteLoading) return;

    const currentScrollY = window.scrollY;

    /* Підвантажуємо тільки при прокручуванні ВНИЗ */
    if (currentScrollY <= lastScrollY) {
      lastScrollY = currentScrollY;
      return;
    }

    lastScrollY = currentScrollY;

    const triggerPosition =
      trigger.getBoundingClientRect().top;

    /*
      Завантажуємо, тільки коли користувач
      наблизився приблизно на 250px до кінця.
    */
    if (triggerPosition < window.innerHeight + 150) {
      loadInfiniteProducts(trigger);
    }
  }

  document.addEventListener('click', (event) => {
    const button =
      event.target.closest(buttonSelector);

    if (!button) return;

    event.preventDefault();

    loadMoreButton(button);
  });

  let ticking = false;

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        checkInfiniteScroll();
        ticking = false;
      });
    },
    { passive: true }
  );
})();